import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_MY_TASKS_EXCEL_REQUEST = 'DOWNLOAD_MY_TASKS_EXCEL_REQUEST';
export const DOWNLOAD_MY_TASKS_EXCEL_SUCCESS = 'DOWNLOAD_MY_TASKS_EXCEL_SUCCESS';
export const DOWNLOAD_MY_TASKS_EXCEL_FAILURE = 'DOWNLOAD_MY_TASKS_EXCEL_FAILURE';

export type MyTasksExcelState = DefaultState;

interface MyTasksExcelRequest {
  type: typeof DOWNLOAD_MY_TASKS_EXCEL_REQUEST;
};

interface MyTasksExcelSuccess {
  type: typeof DOWNLOAD_MY_TASKS_EXCEL_SUCCESS,
}

interface MyTasksExcelFailure {
  type: typeof DOWNLOAD_MY_TASKS_EXCEL_FAILURE;
}

export type MyTasksExcelActionTypes = MyTasksExcelRequest | MyTasksExcelSuccess | MyTasksExcelFailure;